
<component :is="component" :class="`w-${size} h-${size}`" />
